module.exports = __webpack_public_path__ + "img/edit.7ed69cbd.svg";